import {Box, Tooltip} from "@mui/material";
import React, {ReactNode, useState} from "react";
import {Colors} from "../../colors";
import {Container} from "../Container";
import {Text} from "../Text";
import {Divider} from "../Divider";

interface ITimeline {
  icon?: ReactNode;
  date?: string;
  children?: ReactNode;
  onDateClick?: () => void;
  dateTooltip?: string;
  dateClickedTooltip?: string;
}

const dateStyle = {
  backgroundColor: Colors.bw.white,
  padding: "1px 10px",
  borderRadius: "12px",
  whiteSpace: "nowrap",
  textTransform: "uppercase",
};

interface IClickableDate {
  date: string;
  onClick: () => void;
  tooltip?: string;
  clickedTooltip?: string;
}

const ClickableDate = ({date, onClick, tooltip, clickedTooltip}: IClickableDate) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const handleClick = () => {
    onClick();
    setIsClicked(true);
  };

  return (
    <Tooltip title={(isClicked ? clickedTooltip : tooltip) ?? ""} placement="right" arrow>
      <Box
        onClick={handleClick}
        onMouseEnter={() => setIsClicked(false)}
        sx={{cursor: "pointer", borderRadius: "12px", "&:hover": {outline: `2px solid ${Colors.bw.black}`}}}
      >
        <Text size={11} fontWeight={"medium"} sx={dateStyle}>
          {date}
        </Text>
      </Box>
    </Tooltip>
  );
};

export const TimelineItem = ({icon, date, children, onDateClick, dateTooltip, dateClickedTooltip}: ITimeline) => {
  return (
    <Container fullWidth row sx={{alignItems: "end", gap: "16px"}}>
      {icon && (
        <Container sx={{height: "100%", gap: "0px"}}>
          <Divider sx={{width: "2px", height: "34%"}} />
          <Container sx={{width: "54px", height: "54px"}}>{icon}</Container>
          <Divider sx={{width: "2px", height: "100%"}} />
        </Container>
      )}
      {date && (
        <Container sx={{paddingTop: "32px", marginLeft: "-10px"}}>
          {onDateClick ? (
            <ClickableDate
              date={date}
              onClick={onDateClick}
              tooltip={dateTooltip}
              clickedTooltip={dateClickedTooltip}
            />
          ) : (
            <Text size={11} fontWeight={"medium"} sx={dateStyle}>
              {date}
            </Text>
          )}
        </Container>
      )}
      {children}
    </Container>
  );
};
